import {
  Box,
  VStack,
  chakra,
  keyframes,
  useColorModeValue,
  Stack,
  Flex,
  Heading,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import Header from '../../../../components/Header/Header';
import CardHeaderMobile from '../../../../components/Mobile/header';
import LabelWithValueMobilePage from '../../../../components/Mobile/labelWithValue';
import HeaderSectionMobilePage from '../../../../components/Mobile/headerSection';
import TitleSectionMobilePage from '../../../../components/Mobile/titleSection';
import ProofLocationButton from '../../../../components/PDFs/DownloadPDFButton/proofLocationButton';
import { IProofLocationSpecialCompetitionProps } from '../../../../services/hooks/ProofLocation/useGetProofLocationSpecialResultCompetition';

const floatIn = keyframes`
  from { opacity: 0; transform: translateY(18px) scale(0.995); }
  to   { opacity: 1; transform: translateY(0px) scale(1); }
`;
const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

interface IOwnProps {
  title: string;
  data?: IProofLocationSpecialCompetitionProps;
}

const AllocationInfoMobilePage: React.FC<IOwnProps> = ({ data, title }) => {
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  // function subDay(dataStr: string) {
  //   const [dia, mes, ano] = dataStr.split('/').map(Number);
  //   const data = new Date(ano, mes - 1, dia);
  //   data.setDate(data.getDate() - 1);
  //   const novoDia = String(data.getDate()).padStart(2, '0');
  //   const novoMes = String(data.getMonth() + 1).padStart(2, '0');
  //   const novoAno = data.getFullYear();
  //   return `${novoDia}/${novoMes}/${novoAno}`;
  // }

  return (
    <Stack h="100dvh" w="100dvw">
      <Stack height="100%" w="100%" top={0} gap={0}>
        <Header showGoBack />
        <VStack mt={0} flex={1} overflowY="auto" py={2}>
          <AnimatedBox
            borderRadius="lg"
            boxShadow="lg"
            mx={3}
            p={{ base: 5, md: 10 }}
            borderWidth={'1px'}
            borderColor={borderColor}
            bg="white"
            flex={1}
            display="flex"
          >
            <VStack boxSizing="border-box" flex={1} spacing={6} align="stretch">
              <CardHeaderMobile
                title={title}
                subTitle="Proteja sua conta com uma senha forte — nunca compartilhe com ninguém."
              />
              <Box w="full" gap={5}>
                <Stack spacing={1}>
                  <Heading mb={data?.step_title ? 2 : 5} mt={1} size="sm" textAlign="center">
                    CARTÃO DE CONVOCAÇÃO DE PROVA
                  </Heading>
                  {data?.step_title && (
                    <Text size="sm" fontWeight="semibold" textAlign="center" mb={3}>
                      {data?.step_title.toUpperCase()}
                    </Text>
                  )}
                  <HeaderSectionMobilePage>{data?.notice_name}</HeaderSectionMobilePage>
                </Stack>
                <Flex direction={{ base: 'column', md: 'row' }} gap={3} align="flex-start">
                  <Stack flex={1} mt={2}>
                    <Box bgColor="white" boxShadow="md" boxSizing="border-box" p={5}>
                      <TitleSectionMobilePage>Dados do(a) candidato(a)</TitleSectionMobilePage>
                      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mt={4}>
                        <LabelWithValueMobilePage label="Inscrição" value={data?.registration_code.toString()} />
                        <LabelWithValueMobilePage
                          label={data?.is_cultural_house ? 'Turma' : 'Vaga/Cargo'}
                          value={data?.first_vacancy}
                        />
                        {data?.second_vacancy && (
                          <LabelWithValueMobilePage label="Segunda Opção" value={data?.second_vacancy} />
                        )}
                        <LabelWithValueMobilePage label="Nome completo" value={data?.candidate.candidate_name} />
                        <LabelWithValueMobilePage label="CPF" value={data?.candidate.cpf} />
                        <LabelWithValueMobilePage label="Documento" value={data?.candidate.document_number} />
                        <LabelWithValueMobilePage label="Data de nascimento" value={data?.candidate.date_of_birth} />
                        <LabelWithValueMobilePage label="Endereço" value={data?.candidate.candidate_address} />
                        <LabelWithValueMobilePage label="Telefone celular" value={data?.candidate.cellphone} />
                      </SimpleGrid>
                    </Box>
                    <Box bgColor="white" boxShadow="md" boxSizing="border-box" p={5} mt={2}>
                      <TitleSectionMobilePage>Dados para realização da prova</TitleSectionMobilePage>
                      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mt={4}>
                        <LabelWithValueMobilePage
                          label="Local de prova"
                          value={data?.candidate_allocation.test_site_name}
                        />
                        <LabelWithValueMobilePage
                          label="Sala"
                          value={`${data?.exam_schedule.exam_schedule_room_name || data?.candidate_allocation.test_room_name} ${
                            data?.candidate_allocation.details ? `(${data.candidate_allocation.details})` : ''
                          }`}
                        />
                        <LabelWithValueMobilePage
                          label="Endereço"
                          value={data?.candidate_allocation.test_site_address}
                        />
                        <LabelWithValueMobilePage
                          label="Data da prova"
                          value={data?.exam_schedule.exam_schedule_date || data?.candidate_allocation.test_date}
                        />
                        {(data?.has_exam_schedule && (
                          <>
                            <LabelWithValueMobilePage
                              label="Inicio da prova"
                              value={data?.exam_schedule.exam_schedule_start_time}
                            />
                            {/* <LabelWithValueMobilePage
                              label="Data e hora do sorteio do ponto"
                              value={`${data?.exam_schedule.exam_schedule_date ? subDay(data?.exam_schedule.exam_schedule_date) : '--'} ${data?.exam_schedule.exam_schedule_start_time || '--'}H`}
                            /> */}
                          </>
                        )) || (
                          <>
                            <LabelWithValueMobilePage
                              label="Hora da prova"
                              value={data?.candidate_allocation.test_hour}
                            />
                            <LabelWithValueMobilePage
                              label="Abertura dos portões"
                              value={data?.candidate_allocation.gate_opening_time}
                            />
                            <LabelWithValueMobilePage
                              label="Fechamento dos portões"
                              value={data?.candidate_allocation.gate_closing_time}
                            />
                          </>
                        )}
                      </SimpleGrid>
                    </Box>
                    {data?.candidate_registration_card && (
                      <Box bgColor="white" boxShadow="md" boxSizing="border-box" p={5} mt={2}>
                        <TitleSectionMobilePage mb={4}>Informações importantes</TitleSectionMobilePage>
                        <LabelWithValueMobilePage value={data?.candidate_registration_card} acceptTag />
                      </Box>
                    )}
                  </Stack>

                  <VStack align="stretch" w="100%" mt={2}>
                    <ProofLocationButton data={data} />
                  </VStack>
                </Flex>
              </Box>
            </VStack>
          </AnimatedBox>
        </VStack>
      </Stack>
    </Stack>
  );
};

export default AllocationInfoMobilePage;
